/** GUID → slug maps mirrored from DermoScan patient register options. */

const MEDICAL_HISTORY_SLUG_TO_ID: Record<string, string> = {
  moles_over_20: '3c7a4a65-4f19-4c21-9f8b-3e2a91d5b6c0',
  moles_on_arms: '1f8b2e6d-9c73-4a15-8d24-7e3f6a9b0c12',
  sunburns_over_5: '8d5e2f91-6b4a-4c83-9a17-2f6c0e7b3d55',
  blistering_sunburn_history: '5b91d7e4-2a8c-4f36-9e05-1c7a6f2d8b44',
  recent_tanning: '9e2c5a71-3f6b-48d4-8a92-6b1d7f0c4e33',
  chronic_sun_exposure: '2a6f8c93-7d41-4e5b-91c8-0f3d6a9b2e77',
  intermittent_sun_exposure: '6c1e9b42-5a7f-4d83-8f20-9a3d7e6b1c55',
  artificial_uv_exposure: '4f7a2d91-8b63-45c0-9e16-3d5b7a0f2c88',
  sunny_climate_residence: '7d3b5f82-1a6e-4c94-8f37-2b9e0a6c5d11',
  eczema: '0a7f3c91-6d25-4e8b-9f14-5c2a8d7e3b66',
  vitiligo: 'c1e5a7d3-9b42-4f68-8a31-6d0f2e9c7b55',
  psoriasis: 'f6b3d1a9-2e84-4c57-9a20-8d5f1c7e4b33',
  familial_atypical_mole_syndrome: 'b8e2c6f1-5a73-4d09-8f41-3c7a9d0e6b22',
  xeroderma_pigmentosum: '9a4d7f2e-1b63-4c85-8e30-6f2c9a7d5b44',
  congenital_melanocytic_nevi: '2e7c5a91-8f34-4b60-9d12-7a3f6c0e8b55',
  dysplastic_nevus_syndrome: '6f9b1d42-3c85-4e7a-8a21-0d5e7c3b9f66',
  actinic_keratosis: '3b5d9e71-7a24-4f86-8c10-5e2a7d9f3b88',
  mole_biopsy_history: '8c2f6a91-4d73-45e8-9b31-6a0f3d7e5c22',
  melanoma_history: '1a9f6c42-7d35-4e80-8b12-3c5e7a0d9f66',
  other_skin_cancers: '5e2b8d91-6a73-4c40-9f15-7d3c0e6a8b44',
  other_cancer_history: '7f4a1d63-2c85-4e90-8b31-6d0e9c5a3f22',
  family_melanoma_history: '2c8e5a71-9f34-4b60-8d12-5a7f3c0e6b88',
  brca_hereditary_cancer: '9d1b6f42-3a85-4e70-8c21-0f5e7a3d9b55',
  organ_transplant: '4a7d2f91-8b63-45c0-9e16-3d5b7a0f2c99',
  hsct_history: '6b3e9c51-2a84-4f67-8d20-7c5a1e9b3f44',
  immunodeficiency: '0e8c5a91-7f34-4b60-9d12-6a3f2c0e8b77',
  diabetes: '3f2a7d91-6b84-4c50-9e16-8d5b0a7c3f22',
  hypertension: '8a6d1f42-3c95-4e70-8b21-0f5e7a3d9c66',
  sleep_disorders: '5c9e2a71-7f34-4b60-8d12-6a3f0e7b5c88',
  arrhythmia: '1d7b5f82-4a6e-4c94-8f37-2b9e0a6c5d22',
  coronary_artery_disease: '7e3c9a51-2f84-4d67-8b20-6c5a1e9d3f44',
  heart_failure: '9f4b1d63-2c85-4e90-8b31-6d0e9c5a3f33',
  asthma: '2b8e5a71-9f34-4c60-8d12-5a7f3c0e6b99',
  copd: '6d1b7f42-3a85-4e70-8c21-0f5e7a3d9b77',
  werner_syndrome: '4c7a2f91-8b63-45d0-9e16-3d5b7a0f2c55',
  li_fraumeni_syndrome: '0f3e9c51-2a84-4f67-8d20-7c5a1e9b3f66',
  retinoblastoma: '8e5c1a91-7f34-4b60-9d12-6a3f2c0e8b44',
};

const MEDICATION_SLUG_TO_ID: Record<string, string> = {
  immunomodulators: '2f7d3b2a-9a61-4a4e-8f13-6b2f6a9d41e1',
  valproate: 'a63b2d9f-41c7-44a1-8f7b-2d7a06e0b91c',
  puva_treatment: 'f19e56c3-812a-4f86-923c-781d67e4b2a5',
  isotretinoin: '7a92d8f1-35b4-4d9a-91f8-5c6d2e1b3a44',
  antihypertensives: 'c4e2a9b7-8d31-4f29-8d77-91f3c5a6b2e0',
  diuretics: 'b51f7e2c-6a9d-45f4-bb13-2d87f3e9a601',
  amiodarone: 'e83a5d91-27c6-4fb8-9c1d-70f4a2b6d8e3',
  statins: '9d4b7f2a-3e81-4c6f-91a7-5f2e8c0b6d34',
  pde5_inhibitor: '6f2a91c8-5b7e-4d3f-9a62-1c8e7b4d5f90',
  nsaid: 'd27c8a5f-9e14-4b6a-83f1-7a2d5c9e0b61',
  hydroxychloroquine: '4b8e1f6a-2d73-4c9f-91e5-8a0b6d2f7c13',
  methyldopa: '1e6f9a3b-7c24-4d8e-85a1-6b2f0c9d7e43',
};

const MEDICAL_HISTORY_ID_TO_SLUG = Object.fromEntries(
  Object.entries(MEDICAL_HISTORY_SLUG_TO_ID).map(([slug, id]) => [
    id.toLowerCase(),
    slug,
  ])
);

const MEDICATION_ID_TO_SLUG = Object.fromEntries(
  Object.entries(MEDICATION_SLUG_TO_ID).map(([slug, id]) => [
    id.toLowerCase(),
    slug,
  ])
);

export interface NamedReference {
  id?: string;
  name?: string;
}

export type NamedReferenceInput = string | NamedReference | null | undefined;

/** Normalizes API string or { id, name } items into a consistent shape. */
export function mapToNamedReference(
  item: NamedReferenceInput
): { id: string; name: string } | null {
  if (item == null) return null;

  if (typeof item === 'string') {
    const name = item.trim();
    return name ? { id: '', name } : null;
  }

  const id = (item.id ?? '').trim();
  const name = (item.name ?? '').trim();
  if (!id && !name) return null;
  return { id, name };
}

export function mapToNamedReferences(
  items: NamedReferenceInput[] | null | undefined
): Array<{ id: string; name: string }> {
  return (items ?? [])
    .map(mapToNamedReference)
    .filter((item): item is { id: string; name: string } => item != null);
}

export function medicalHistoryI18nKey(id?: string | null): string | null {
  if (!id?.trim()) return null;
  const slug = MEDICAL_HISTORY_ID_TO_SLUG[id.trim().toLowerCase()];
  return slug ? `auth.register.medical.option.${slug}` : null;
}

export function medicationI18nKey(id?: string | null): string | null {
  if (!id?.trim()) return null;
  const slug = MEDICATION_ID_TO_SLUG[id.trim().toLowerCase()];
  return slug ? `auth.register.medication.option.${slug}` : null;
}

export function localizeNamedReference(
  translate: (key: string) => string,
  item: NamedReferenceInput,
  kind: 'medical' | 'medication'
): string {
  if (item == null) return '';
  if (typeof item === 'string') {
    return item.trim();
  }

  const fallback = (item.name ?? '').trim();
  const key =
    kind === 'medical'
      ? medicalHistoryI18nKey(item.id)
      : medicationI18nKey(item.id);

  if (!key) return fallback;

  const localized = translate(key);
  if (!localized || localized === key) return fallback;
  return localized;
}
